import { render } from "./Error404.vue?vue&type=template&id=354ea2e0&scoped=true&ts=true"
import script from "./Error404.vue?vue&type=script&lang=ts"
export * from "./Error404.vue?vue&type=script&lang=ts"

import "./Error404.vue?vue&type=style&index=0&id=354ea2e0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354ea2e0"]])

export default __exports__